import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> { }

const TextIcon: React.FC<Props> = (props) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.834 9.58335H14.1673" stroke="#008AF6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.5007 9.58331V12.9166" stroke="#008AF6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.83398 7.08335H10.834" stroke="#008AF6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.33268 7.08331V12.9166" stroke="#008AF6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="2.5" y="2.5" width="15" height="15" rx="5" stroke="#008AF6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  );
};

export default TextIcon;
